import client from "../../../api/client";

export default async function getRoomListings(params = {}) {
    const response = await client.get("/room-listings", {
        params,
    });

    return response.data;
}